import React from "react";
import { Button, Form, Modal } from 'react-bootstrap';
import Locale from "../../../locale/Locale";

export default class StatusList extends React.Component {

    state = {};

    render() {
        return (
            <div className="CurrentStatusList">
                <div className="row">
                    <div className="col-md-3 pull-left">
                        <Form.Control 
                            type="text"
                            //value={ this.state.stateSearch }
                            onChange={ (event) => {
                                if (this.stateSearchTimeout)
                                    clearTimeout(this.stateSearchTimeout);
                                let phrase = event.target.value;
                                this.stateSearchTimeout = setTimeout(() => {
                                    this.setState({ stateSearch: phrase });
                                }, 200);
                            }}
                        />
                    </div>
                    <div className="col-md-2 pull-right">
                        <Button onClick={ () => this.props.detailScreen.updateStatus() }>Refresh</Button>
                    </div>
                    <div className="col-md-2 pull-right">
                        { this.props.detailScreen.state.itemStatus.length } rows
                    </div>
                </div>
                <table style={{ width: '100%' }}>
                    <thead>
                        <tr style={{ border: "1px solid black" }}>
                            <td style={{ width: 100 }}>Time</td>
                            <td>Device</td>
                            <td>Param</td>
                            <td>Status</td>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        this.props.detailScreen.state.itemStatus.map(item => {
                            let isController = this.props.detailScreen.state.itemConfig.Controllers?.find((dev) => dev.UUID === item.item);
                            let deviceObj = this.props.detailScreen.state.itemConfig.Location?.UUID === item.item ? { Name: "Site" } :
                                            isController ? { Name: "Device " + isController.Number } : 
                                            this.props.detailScreen.state.itemConfig.Devices?.find((dev) => dev.UUID === item.item) || 
                                            this.props.detailScreen.state.itemConfig.BodiesOfWater?.find((dev) => dev.UUID === item.item) || 
                                            this.props.detailScreen.state.itemConfig.WaterFeatures?.find((dev) => dev.UUID === item.item);
                            return {
                                Param: item.name,
                                Device: item.item,
                                deviceObj,
                                Status: item.state,
                                time: item.updated
                            };
                        })
                        .filter((row) => {
                            if (typeof row.Device === "undefined" || row.Device.indexOf('FACTORY-MODE') !== -1) {
                                return false;
                            }
                            
                            if (this.state.stateSearch?.length > 0) {
                                let sf = this.state.stateSearch.toLowerCase();
                                if (
                                    (!row.deviceObj?.Name || row.deviceObj?.Name?.toLowerCase().indexOf(sf) === -1) &&
                                    (!row?.Device || row.Device?.toLowerCase().indexOf(sf) === -1) &&
                                    (!row?.Status || row.Status?.toLowerCase().indexOf(sf) === -1) &&
                                    (!row?.Param || row.Param?.toLowerCase().indexOf(sf) === -1) &&
                                    (!row?.ParamName || row.ParamName?.toLowerCase().indexOf(sf) === -1)
                                ) {
                                    return false;
                                }
                            }
                            return true;
                        })
                        .sort((rowA, rowB) => {
                            return (rowA.deviceObj?.Name || rowA.Device) < (rowB.deviceObj?.Name || rowB.Device) ? -1 : 1;
                        })
                        .map((row, key) => {
                            let stamp = new Date(row.time);
                            //if (!row.deviceObj)
                            //    console.log(row);
                            return (
                                <tr key={"row_" + row.Device + "_" + row.Param + "_" + row.time}>
                                    <td>
                                        { Locale.formatDateTime(stamp, true) }
                                    </td>
                                    <td>{ row.deviceObj ? (row.deviceObj.Name || row.deviceObj.DeviceType) : "" }<br/>
                                        { row.Device }
                                    </td>
                                    <td>{ row.Param }</td>
                                    <td>{ ( row.Status?.length > 15 ) ?
                                            ( <Button
                                                style={{  }}
                                                onClick={ () => {
                                                    let displayVal = row.Status;
                                                    try {
                                                        displayVal = JSON.parse(row.Status);
                                                    } catch {

                                                    }
                                                    this.props.detailScreen.extraElement = (
                                                        <Modal
                                                            show={ true } 
                                                            scrollable={ true }
                                                            backdrop="static"
                                                            onHide={ () => { this.props.detailScreen.clearExtraElement(); } }
                                                            dialogClassName="wideDialog"
                                                        >
                                                            <Modal.Header closeButton >
                                                                <Modal.Title>State info</Modal.Title>
                                                            </Modal.Header>
                                                            <Modal.Body style={{  }} >
                                                                <div style={{ display: 'inline-block', width: '45%', verticalAlign: 'top' }}>
                                                                    <pre>
                                                                    { JSON.stringify(displayVal, null, 2) }
                                                                    </pre>
                                                                </div>
                                                            </Modal.Body>
                                                            <Modal.Footer>
                                                                <Button variant="secondary" onClick={ () => { this.props.detailScreen.clearExtraElement(); }}>Close</Button>
                                                            </Modal.Footer>
                                                        </Modal>
                                                    );
                                                    this.props.detailScreen.setState({});
                                                } }
                                                >Details</Button>
                                            ) : row.Status
                                    }</td>
                                </tr>
                            )
                        }).filter(item => item !== null)
                    }
                    </tbody>
                </table>
            </div>
        );
    }
}